import React, { useState } from 'react'
import DashboardLayout from 'layout/DashboardLayout'
import CreateApplicationModal from 'components/Modals/CreateApplication'
import RunningApplications from './components/Applications'

const Dashboard = () => {
    const [showModal, setShowModal] = useState(false)
    return (
        <DashboardLayout>
            <div className='w-11/12 md:w-10/12 mx-auto grid grid-cols-9 mt-5 md:mt-12 gap-10 lg:gap-6 xl:gap-10'>
                <div className='col-span-9 lg:col-span-6 pt-2'>
                    <div className='flex items-center justify-between lg:w-11/12'>
                        <div>
                            <p className='text-dark font-medium text-lg tracking-wide'>Running applications</p>
                        </div>
                        <div className='w-7/12 md:w-auto flex justify-end'>
                            <button
                                className='bg-green px-5 py-1 text-white rounded-xs text-xs flex items-center'
                                onClick={() => setShowModal(true)}
                            >
                                <span aria-label='plus' className='text-xl pr-2'>
                                    +
                                </span>
                                New application
                            </button>
                        </div>
                    </div>
                    <div className="mt-5">
                        <RunningApplications />
                    </div>
                </div>

                <div className='col-span-9 md:col-span-5 lg:col-span-3'>
                    <div className='bg-smoke-100 rounded-lg w-full px-8 relative pt-6'>
                        <div>
                            <svg
                                width='40'
                                height='40'
                                viewBox='0 0 40 40'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                            >
                                <path
                                    d='M33.3335 5H6.66683C4.82588 5 3.3335 6.49238 3.3335 8.33333V31.6667C3.3335 33.5076 4.82588 35 6.66683 35H33.3335C35.1744 35 36.6668 33.5076 36.6668 31.6667V8.33333C36.6668 6.49238 35.1744 5 33.3335 5Z'
                                    fill='#52BD95'
                                />
                                <path
                                    opacity='0.6'
                                    d='M16.581 22.1938C16.3541 22.8743 15.7172 23.3334 14.9998 23.3334H8.33317C7.4127 23.3334 6.6665 22.5872 6.6665 21.6667C6.6665 20.7463 7.4127 20.0001 8.33317 20.0001H13.7986L16.752 11.1397C17.2793 9.55784 19.5457 9.64488 19.9501 11.2625L23.024 23.5583L24.3425 20.9214C24.6248 20.3567 25.2019 20.0001 25.8332 20.0001H31.6665C32.587 20.0001 33.3332 20.7463 33.3332 21.6667C33.3332 22.5872 32.587 23.3334 31.6665 23.3334H26.8632L23.9905 29.0788C23.2986 30.4627 21.2582 30.2388 20.8829 28.7376L18.1044 17.6235L16.581 22.1938Z'
                                    fill='white'
                                />
                                <path
                                    opacity='0.3'
                                    d='M31.6667 11.6667C32.5871 11.6667 33.3333 10.9205 33.3333 10C33.3333 9.07957 32.5871 8.33337 31.6667 8.33337C30.7462 8.33337 30 9.07957 30 10C30 10.9205 30.7462 11.6667 31.6667 11.6667Z'
                                    fill='#BAE5D5'
                                />
                            </svg>
                            <p className='text-dark font-medium text-2xl pt-3'>Test Environment</p>
                            <p className='text-dark opacity-50 text-base pt-2'>
                                Here you can test how our systems works, Click the button to experience it.
                            </p>
                            <div className='mt-8'>
                                <button className='bg-white border border-smoke-200 px-10 py-2 rounded-xs text-sm relative z-50'>
                                    Launch test
                                </button>
                            </div>
                            <div className='h-40 w-full'></div>
                        </div>
                        <div className='absolute bottom-0 right-0 w-11/12'>
                            <img src={require('assets/img/pole.png')} alt='pole' className='w-4/12 ml-auto' />
                        </div>
                    </div>
                </div>
            </div>
            <div className='h-20'></div>
            <CreateApplicationModal show={showModal} close={() => setShowModal(false)} />
        </DashboardLayout>
    )
}

export default Dashboard
